module.exports = __webpack_public_path__ + "static/img/xiangqing_bg.efb068d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/xiangqing_bg.png
// module id = 75C7
// module chunks = 2